(() => {
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));
  const qs = (s, r=document) => r.querySelector(s);

  function buildLightbox() {
    let lb = qs('.ei-lightbox');
    if (lb) return lb;

    lb = document.createElement('div');
    lb.className = 'ei-lightbox';
    lb.innerHTML = `
      <div class="ei-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Image viewer">
        <div class="ei-lightbox__bar">
          <div class="ei-lightbox__cap" data-cap></div>
          <div class="ei-lightbox__btns">
            <button class="ei-btn" type="button" data-prev aria-label="Previous image">←</button>
            <button class="ei-btn" type="button" data-next aria-label="Next image">→</button>
            <button class="ei-btn" type="button" data-close aria-label="Close">✕</button>
          </div>
        </div>
        <div class="ei-lightbox__imgwrap">
          <img data-img alt="">
        </div>
      </div>
    `;
    document.body.appendChild(lb);

    lb.addEventListener('click', (e) => {
      const dialog = qs('.ei-lightbox__dialog', lb);
      if (!dialog.contains(e.target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });

    const img = qs('[data-img]', lb);
    const cap = qs('[data-cap]', lb);
    const btnPrev = qs('[data-prev]', lb);
    const btnNext = qs('[data-next]', lb);
    const btnClose = qs('[data-close]', lb);

    let items = [];
    let index = 0;
    let lastFocus = null;

    function render() {
      const it = items[index];
      if (!it) return;
      img.src = it.src;
      img.alt = it.alt || '';
      cap.textContent = it.alt || '';
      btnPrev.disabled = items.length <= 1;
      btnNext.disabled = items.length <= 1;
    }
    function open(newItems, startIndex, focusEl) {
      items = newItems || [];
      index = Math.max(0, Math.min(startIndex || 0, items.length - 1));
      lastFocus = focusEl || null;
      render();
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      btnClose.focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    function prev() { index = (index - 1 + items.length) % items.length; render(); }
    function next() { index = (index + 1) % items.length; render(); }

    btnPrev.addEventListener('click', prev);
    btnNext.addEventListener('click', next);
    btnClose.addEventListener('click', close);

    return { open, close };
  }

  const lightbox = buildLightbox();

  
  qsa('[data-ei-gallery]').forEach(gal => {
    const triggers = qsa('[data-ei-lightbox-trigger]', gal);
    const items = triggers
      .map(btn => ({
        src: btn.getAttribute('data-src') || '',
        alt: btn.getAttribute('data-alt') || ''
      }))
      .filter(it => it.src);

    triggers.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        lightbox.open(items, i, btn);
      });
    });
  });

  
  qsa('[data-ei-tabs]').forEach(root => {
    const tabs = qsa('[role="tab"]', root);
    const panels = qsa('[role="tabpanel"]', root);

    function activate(name) {
      tabs.forEach(t => t.setAttribute('aria-selected', t.dataset.chef === name ? 'true' : 'false'));
      panels.forEach(p => p.hidden = p.dataset.chef !== name);
    }
    tabs.forEach(t => t.addEventListener('click', () => activate(t.dataset.chef)));
    const first = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
    if (first) activate(first.dataset.chef);
  });
})();
